// src/components/intake/IntakeSaleLocation.js
//
// Ticket 064 (screen 3.3, D4). Where the property that was sold was. A firm
// country is required: exactly the three PROPERTY_LOCATION_OPTIONS and NO
// "Not sure". Shown only when "Sold a property" was ticked and no property-sale
// card already fixes the country.

import React from 'react'
import IntakeOptionButton from './IntakeOptionButton'
import { PROPERTY_LOCATION_OPTIONS } from '../../lib/intake/intakeConfig'

export default function IntakeSaleLocation({ value, onChange }) {
  return (
    <div className="u-stack-xs">
      {PROPERTY_LOCATION_OPTIONS.map((o) => (
        <IntakeOptionButton key={o.value} label={o.label} selected={value === o.value} onClick={() => onChange(o.value)} />
      ))}
    </div>
  )
}
